// extracted by mini-css-extract-plugin
module.exports = {"inputField":"styles_inputField__xgbXa","labelWrapper":"styles_labelWrapper__1FwJK"};